<template>
  <div class="pt-0 hyp-content-details-container">
    <div v-if="!isMinimized">
      <div class="details-container">
        <v-row>
          <v-col cols="6" class="pt-0 col col-6 pl-6">
            <h1>
              <v-icon
                v-if="!isMinimized"
                size="18"
                @click="handleClickMinimize"
                title="Back to Map"
                class="mr-3"
                >fas fa-arrow-left</v-icon
              >
              <span>
                {{ selectedLocation.name }} Cities ({{ cities.length }})
              </span>
            </h1>
          </v-col>
          <v-col cols="6" class="pt-0 pr-6 col col-6 text-right">
            <RisksReport
              class="pl-2 pull-right"
              v-if="selectedCity"
              :selected-location="selectedCity"
            ></RisksReport>
            <v-btn
              @click="openLocationWatch"
              color="primary"
              v-if="!hasEssentials"
              small
            >
              <span>Watch Location</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-sheet>
          <v-btn
            class="pull-left text-capitalize hyp-back-to-country-btn"
            x-large
            color="success"
            plain
            text
            @click="handleClickBackToCountry"
          >
            Back to {{ selectedLocation.name }}
          </v-btn>
          <v-tabs
            v-model="selectedCityCode"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tab
              v-for="item in cities"
              :key="item.code"
              :href="'#' + item.code"
              class="hyp-risk-tabs"
              @click="handleChangeCity(item)"
            >
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </v-sheet>

        <Loader
          v-if="loading"
          :text="loaderText"
          size="small"
          class="mt-5"
        ></Loader>
        <v-row v-if="!cityDetails && !hasContent && !loading">
          <v-col class="col-12 pa-4">
            The information for {{ this.selectedCity.name }} is not available
            within Seerist. Please check back periodically as we continue to
            update our city coverage.
          </v-col>
        </v-row>
        <v-container v-if="cityDetails" class="hyp-risk-details-container">
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-container class="hyp-risk-tab-items mt-3">
                <v-row id="hyp-risk-grid">
                  <v-col
                    id="hyp-risk-content-wrapper"
                    cols="12"
                    class="pt-0 content-container hyp-risk-grid-2"
                  >
                    <!--Facts-->
                    <RisksContentContainerWrapper
                      class="mb-2 pa-3 hyp-risk-grid-2-left1"
                      wrapper-id="risks-city-facts"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <div>
                        <div class="hyp-grid-details-container">
                          <div class="details-heading application-heading mb-1">
                            {{ cityDetails.name }} Facts
                            <SimpleDialog
                              dialog-class="float-right"
                              :show-sidebar="true"
                            >
                              <template v-slot:dialogButton>
                                <v-btn
                                  class="pull-right"
                                  color="success"
                                  outlined
                                  plain
                                  small
                                >
                                  <v-icon left x-small>
                                    fas fa-info-circle
                                  </v-icon>
                                  Our Methodology
                                </v-btn>
                              </template>

                              <template>
                                <RisksProfileBody
                                  v-if="cityMethodology"
                                  :profile-info="cityMethodology"
                                ></RisksProfileBody>
                              </template>
                            </SimpleDialog>
                          </div>

                          <div v-if="citySnapshot">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr
                                    v-for="item in citySnapshot"
                                    :key="item[0]"
                                  >
                                    <td class="text-capitalize">
                                      {{ item[0] }}
                                    </td>
                                    <td>{{ item[1] }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                        </div>
                      </div>
                    </RisksContentContainerWrapper>
                    <!--Pulse-->
                    <RisksPulseRatings
                      class="mb-2 hyp-risk-grid-2-right"
                      v-if="selectedCity"
                      :selected-location="selectedCity"
                      :risksContentExpanded="risksPulseRatingsExpanded"
                      :params="params"
                      :selected-primary-risk-category="
                        selectedPrimaryRiskCategory
                      "
                    ></RisksPulseRatings>
                    <!--Overview-->
                    <RisksContentContainerWrapper
                      class="mb-2 pa-3 hyp-risk-grid-2-left1"
                      wrapper-id="risks-city-overview"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <RisksProfileBody
                        v-if="cityOverview"
                        :profile-info="cityOverview"
                      ></RisksProfileBody>
                    </RisksContentContainerWrapper>
                    <!--Map-->
                    <RisksContentContainerWrapper
                      v-if="cityImage && cityImage.url"
                      class="mb-2 pa-3 hyp-risk-grid-2-right1"
                      wrapper-id="risks-city-image"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <div
                        class="hyp-grid-details-container hyp-grid-image-container"
                      >
                        <img
                          class="hyp-risks-city-image pt-2"
                          :src="cityImage.url"
                          :alt="cityImage.alternativeText"
                        />
                      </div>
                    </RisksContentContainerWrapper>
                    <!--Risk City Backgroud-->
                    <RisksContentContainerWrapper
                      class="mb-2 pa-3 hyp-risk-grid-2-left1"
                      wrapper-id="risks-city-background"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <RisksProfileBody
                        v-if="
                          recommendations &&
                          isCityPageEnhancementsFeatureUnlocked
                        "
                        :profile-info="recommendations"
                        container-class="hyp-grid-profile-container"
                      ></RisksProfileBody>
                      <RisksProfileBody
                        v-if="
                          cityBackground &&
                          !isCityPageEnhancementsFeatureUnlocked
                        "
                        :profile-info="cityBackground"
                        container-class="hyp-grid-profile-container"
                      ></RisksProfileBody>
                    </RisksContentContainerWrapper>
                    <!--Arrivals-->
                    <RisksContentContainerWrapper
                      v-if="cityArrivals"
                      class="mb-2 pa-3 hyp-risk-grid-2-right2"
                      wrapper-id="risks-city-arrivals"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <div class="details-heading application-heading">
                        Arrivals
                        <SimpleDialog
                          dialog-class="float-right"
                          :show-sidebar="true"
                        >
                          <template v-slot:dialogButton>
                            <v-btn
                              class="pull-right"
                              color="success"
                              outlined
                              plain
                              small
                            >
                              <v-icon left x-small>
                                fas fa-info-circle
                              </v-icon>
                              Our Methodology
                            </v-btn>
                          </template>

                          <template>
                            <RisksProfileBody
                              v-if="cityMethodology"
                              :profile-info="cityMethodology"
                            ></RisksProfileBody>
                          </template>
                        </SimpleDialog>
                      </div>
                      <v-container class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0">
                          <v-col
                            v-for="(arrival, i) in cityArrivals"
                            :key="i"
                            cols="auto"
                            class="ml-0 mr-2 mb-2 mt-0 pa-0"
                          >
                            <v-card
                              class="my-0 mx-0 pa-2 mx-auto hyp-risks-city-arrivals-cards"
                              outlined
                            >
                              <v-card-text class="ma-0 pa-0">
                                <div>
                                  <div class="text-capitalize pull-left">
                                    <h3>
                                      <strong>{{ arrival.title }}</strong>
                                    </h3>
                                  </div>
                                  <div class="text-overline pull-right">
                                    <v-card
                                      flat
                                      width="60px"
                                      v-for="(r, index) in arrival.ratings"
                                      :key="'r' + index"
                                      class="pull-left hyp-risks-city-arrival-rating-cards"
                                      :class="{ 'hyp-hide': !r.rating }"
                                      :title="r.displayTitle"
                                    >
                                      <v-card-text
                                        class="mx-1 pa-0 text-center"
                                      >
                                        <i
                                          class="fa fa-lg"
                                          :class="getArrivalRatingIconClass(r)"
                                        ></i>
                                        <div class="text-capitalize">
                                          {{ r.rating }}
                                        </div>
                                      </v-card-text>
                                    </v-card>
                                  </div>
                                  <div class="clearfix">
                                    {{ arrival.description }}
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </RisksContentContainerWrapper>
                    <!--Embassies and Consulates-->
                    <RisksContentContainerWrapper
                      v-if="
                        filteredCitiesEmbassies &&
                        isCityPageEnhancementsFeatureUnlocked
                      "
                      class="mb-2 pa-3 hyp-risk-grid-2-right2"
                      wrapper-id="risks-city-embassies"
                      expand-btn-title="View in Full Page"
                      :reset-expanded="resetExpanded"
                      @click-expand="handleClickExpand"
                    >
                      <div class="details-heading application-heading">
                        Embassies / Consulates section
                      </div>
                      <v-row>
                        <v-container class="align-left-container" pb-0 pt-0>
                          <v-col cols="8" class="countrySelectCol pa-0">
                            <v-autocomplete
                              :search-input.sync="inputText"
                              v-model="countryFilters"
                              label="Countries"
                              :items="countryList"
                              @change="handleCountryChange"
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              clearable
                              single-line
                              dense
                            />
                          </v-col>
                        </v-container>
                      </v-row>
                      <v-row class="ma-0 pa-0">
                        <v-container class="cards-container ma-0 pa-0">
                          <!-- Loop through filteredCitiesEmbassies -->
                          <v-col
                            v-for="(embassy, i) in filteredCitiesEmbassies"
                            :key="i"
                            cols="auto"
                            class="ml-0 mr-2 mb-2 mt-0 pa-0"
                          >
                            <v-card class="my-0 mx-0 pa-2 w-full" outlined>
                              <v-card-text class="ma-0 pa-0">
                                <div class="card-content">
                                  <!-- Check if the embassy object is empty -->
                                  <div v-if="!embassy.title">
                                    <p>
                                      Embassy/consulate contact information for
                                      {{ embassy.country.name }} is coming soon.
                                      If you would like to request an update on
                                      this information, please reach out to your
                                      Customer Success Manager to let us know.
                                      Thank you for your patience.
                                    </p>
                                  </div>
                                  <!-- Normal embassy content -->
                                  <div v-else>
                                    <div class="title-section">
                                      <h3 class="text-capitalize">
                                        <strong>{{
                                          embassy.country.name
                                        }}</strong>
                                      </h3>
                                      <strong>{{ embassy.title }}</strong>
                                      <div
                                        @click="openGoogleMaps(embassy.address)"
                                        class="address-text"
                                      >
                                        {{ embassy.address }}
                                      </div>
                                    </div>
                                    <div class="contact-section">
                                      <div v-if="embassy.phone">
                                        Phone:
                                        <span> {{ embassy.phone }}</span>
                                      </div>
                                      <span v-if="embassy.email">
                                        <div
                                          v-for="(email, i) in getEmailList(
                                            embassy.email
                                          )"
                                          :key="i"
                                        >
                                          Email:
                                          <a
                                            @click.stop.prevent="
                                              handleEmailClick(email)
                                            "
                                            class="hyp-link"
                                          >
                                            {{ email }}
                                          </a>
                                        </div>
                                      </span>
                                      <span v-if="embassy.website"
                                        >Website:
                                        <a
                                          @click.stop.prevent="
                                            openSource(embassy.website)
                                          "
                                          :href="embassy.website"
                                          ><span>{{
                                            getBaseUrl(embassy.website)
                                          }}</span>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-container>
                      </v-row>
                    </RisksContentContainerWrapper>
                    <v-card v-else>
                      <div
                        class="details-heading application-heading pa-3 hyp-risk-grid-2-right2"
                      >
                        Embassies / Consulates section
                      </div>
                      <v-col class="col-12 pa-4">
                        Embassy/consulate content for this city is coming soon.
                        If you would like to request an update to this specific
                        city, please reach out to your Customer Success Manager
                        to let us know. Thank you for your patience.
                      </v-col>
                    </v-card>
                    <!--Calendar-->
                    <RisksCalendarEvents
                      :selected-location="getSelectedLocation"
                      :expand-left="false"
                    ></RisksCalendarEvents>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <LeaveAppPopup :link="sourceLink" :show="showSourceLink"></LeaveAppPopup>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirm</v-card-title>
        <v-card-text>Would you like to leave the platform?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="success" text @click="confirmLeave">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";

import {
  RISK_RATING_PRIMARIES,
  ARRIVAL_RATING_TYPES,
  ARRIVAL_RATING_LEVELS,
} from "@/common/constants/controlRisks/risks";
import {
  getCityDetails,
  getRiskRatingsByCityCode,
} from "@/services/controlRisks/risks.service";
import { hasEssentialsAccess } from "@/services/user/user.service";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";
import { MODULE_PREFIX_HOME, MODULE_PREFIX_USER } from "@/store";
import { GET_DETAILS_SIDEBAR } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { getCityMethodology } from "@/services/common/methodology.service";
import { hasSourceLinkPopupAccess } from "@/services/user/user.service";
import { SAVE_PREFERENCES } from "@/store/actions.type";
import { getEmbassyCountriesConfig } from "@/services/common/embassy.service";
import lodashOrderBy from "lodash/orderBy";

const EMITTED_ACTIONS = {
  CLICK_CLOSE: "click-close",
  CLICK_MINIMIZE: "click-minimize",
  CLICK_BACK_TO_COUNTRY: "click-back-to-country",
};

export default {
  name: "RisksCitiesContent",
  components: {
    Loader: () => import("@/components/common/Loader"),
    RisksReport: () => import("@/components/controlRisks/risks/RisksReport"),
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    RisksPulseRatings: () =>
      import("@/components/controlRisks/risks/RisksPulseRatings"),
    RisksProfileBody: () =>
      import("@/components/controlRisks/risks/RisksProfileBody"),
    SimpleDialog: () => import("@/components/common/dialogs/SimpleDialog"),
    RisksCalendarEvents: () =>
      import("@/components/controlRisks/risks/RisksCalendarEvents"),
    LeaveAppPopup: () => import("@/components/common/LeaveAppPopup"),
  },
  props: {
    selectedLocation: {
      type: Object,
    },
    cities: {
      type: Array,
      required: true,
      default: () => [],
    },
    isMinimized: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return { hidePulse: false };
      },
    },
  },
  data() {
    return {
      hasEssentials: hasEssentialsAccess(),
      resetExpanded: new Date().toISOString(),
      selectedCity: null,
      selectedCityCode: null,
      cityDetails: null,
      ratings: null,
      risksPulseRatingsExpanded: null,
      showMethodology: false,
      cityMethodology: null,
      hasContent: true,
      countryFilters: [],
      embassiesPreferences: [],
      loading: false,
      inputText: "",
      countryList: [],
      sourceLink: null,
      showSourceLink: null,
      dialog: false,
      emailToOpen: null,
    };
  },
  async mounted() {
    this.applyPrefs();
    this.countryList = await getEmbassyCountriesConfig();
    this.cityMethodology = await getCityMethodology();
  },
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    isSourcePopupFeatureUnlocked() {
      return hasSourceLinkPopupAccess();
    },
    isCityPageEnhancementsFeatureUnlocked() {
      return this.featureUnlocked("city-page-enhancements");
    },
    selectedPrimaryRiskCategory() {
      return lodashFind(this.ratings, [
        "riskCategoryId",
        RISK_RATING_PRIMARIES.security,
      ]);
    },
    loaderText() {
      const selectedText =
        this.selectedCity && this.selectedCity.name
          ? this.selectedCity.name
          : "";
      return `Loading ${selectedText} details`;
    },
    getSelectedLocation() {
      let selectedLocation = lodashCloneDeep(this.selectedLocation);
      selectedLocation.selectedCity = this.selectedCity;
      return selectedLocation;
    },
    filteredCitiesEmbassies() {
      // If this.cityDetails or this.cityDetails.embassies is empty meaning there is no embassies registered for this city
      // then return null to show the message that there is no embassies for this city.
      if (
        !this.cityDetails?.embassies ||
        this.cityDetails.embassies.length === 0
      ) {
        return null;
      }

      let embassies = this.cityDetails?.embassies || [];

      // Filter based on user preferences stored in embassiesPreferences
      if (this.embassiesPreferences.length > 0) {
        embassies = embassies.filter((embassy) =>
          this.embassiesPreferences.includes(embassy.country.isoAlpha2Code)
        );
      }

      // Further filter by country if any country filter is selected
      if (this.countryFilters.length > 0) {
        embassies = embassies.filter((embassy) =>
          this.countryFilters.includes(embassy.country.isoAlpha2Code)
        );
      }

      // This process is to add the countries that are not in the embassies list since they don't have embassy data
      // we are adding just the country name to show it along with a message that there is no embassy data.
      // Validate if countryFilters have the same length as the countries in embassies
      this.countryFilters.forEach((countryCode) => {
        if (
          !embassies.some(
            (embassy) => embassy.country.isoAlpha2Code === countryCode
          )
        ) {
          // Find the country name from the countryList
          const country = this.countryList.find((c) => c.value === countryCode);
          embassies.push({
            country: {
              name: country?.text,
            },
            title: null, // This indicates no embassy data
          });
        }
      });

      // Sort by country name in ascending order
      return lodashOrderBy(embassies, ["country.name"], ["asc"]);
    },
  },
  methods: {
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
    handleClickMinimize() {
      this.$emit(EMITTED_ACTIONS.CLICK_MINIMIZE);
    },
    handleClickBackToCountry() {
      this.$emit(EMITTED_ACTIONS.CLICK_BACK_TO_COUNTRY);
    },
    handleClickExpand(wrapperId, expandedYN) {
      this.risksPulseRatingsExpanded = null;
      if (wrapperId === "risks-pulse-ratings") {
        this.risksPulseRatingsExpanded = expandedYN ? wrapperId : null;
      }
    },
    handleCountryChange() {
      this.setPrefs();
    },
    handleEmailClick(email) {
      this.emailToOpen = email;
      if (this.isSourcePopupFeatureUnlocked) {
        this.dialog = true;
      } else {
        window.location.href = this.emailToOpen;
      }
    },
    getBaseUrl(url) {
      try {
        const urlObj = new URL(url);
        return `${urlObj.origin}/`;
      } catch (e) {
        return url; // In case the URL is invalid, return it as is.
      }
    },
    getEmailList(emailString) {
      return emailString
        ? emailString.split(";").map((email) => email.trim())
        : [];
    },
    setPrefs() {
      if (this.preferences) {
        // Initialize cityEmbassies as an empty array if it doesn't exist
        if (!Array.isArray(this.preferences.cityEmbassies)) {
          this.preferences.cityEmbassies = [];
        }

        // Update the cityEmbassies array with the current country filters
        this.preferences.cityEmbassies = [...this.countryFilters];

        // If the user has cleared the search, it will clear the preferences
        if (this.countryFilters.length === 0) {
          this.preferences.cityEmbassies = [];
        }

        // Save the updated preferences to the store
        this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );

        this.applyPrefs();
      }
    },
    applyPrefs() {
      this.embassiesPreferences = this.preferences?.cityEmbassies || [];
    },
    confirmLeave() {
      if (this.emailToOpen) {
        const mailtoLink = `mailto:${this.emailToOpen}`;
        window.location.href = mailtoLink;
        this.emailToOpen = null;
      }
      this.dialog = false;
    },
    openSource(url) {
      this.sourceLink = url;
      this.showSourceLink = new Date().toISOString();
    },
    openGoogleMaps(address) {
      const encodedAddress = encodeURIComponent(address);
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      window.open(googleMapsUrl, "_blank");
    },
    openLocationWatch() {
      this.handleClickClose();

      this.detailsSidebar.visible = true;
      this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.monitor;
      this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.monitor;
      this.detailsSidebar.monitorType = DETAIL_SIDEBAR_TYPES.stability;
      this.detailsSidebar.stabilityType = GRIDS_STABILITY_TYPES.city;
      this.detailsSidebar.code = this.selectedCityCode;
      this.detailsSidebar.openMonitor = true;

      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
        this.detailsSidebar
      );
    },
    handleChangeCity(item) {
      this.loading = true;
      if (item) {
        item.type = "city";
        this.selectedCity = item;
        this.selectedCityCode = item.code;
      }
      this.getContent();
      this.getRatings();
    },
    async getContent() {
      this.cityDetails = null;
      try {
        this.cityDetails = (
          (await getCityDetails(this.selectedCityCode)) || {}
        )?.properties?.formatted;
        if (!this.cityDetails) {
          this.hasContent = false;
          return false;
        }
      } catch (error) {
        console.error(
          "There was an error trying to retrieve the data for this city: " +
            this.selectedCityCode
        );
      }
      this.citySnapshot = Object.entries(this.cityDetails?.snapshot).filter(
        ([key, value]) => key != "id"
      );

      this.cityOverview = lodashFind(this.cityDetails?.overview, [
        "type",
        "overview",
      ]);
      this.cityBackground = lodashFind(this.cityDetails?.overview, [
        "type",
        "background",
      ]);

      if (this.isCityPageEnhancementsFeatureUnlocked) {
        this.cityOverview.body = this.cityOverview?.body.concat(
          `<h2>${this.cityBackground?.title}</h2>`,
          this.cityBackground?.body
        );

        this.recommendations = lodashFind(this.cityDetails?.overview, [
          "title",
          "Recommendations",
        ]);

        if (this.recommendations.body === null) {
          this.recommendations.body = `<p>Travel recommendations for ${this.selectedCity.name} are in progress. Please contact your Customer
            Success Manager to request travel advice for ${this.selectedCity.name}.</p>`;
        }
      }

      this.cityImage = this.cityDetails?.image;
      this.cityArrivals = this.cityDetails?.arrivals;

      // here we store the countries from preferences if not then an empty array
      this.countryFilters = this.embassiesPreferences || [];

      return true;
    },
    async getRatings() {
      try {
        const { cities } = (await getRiskRatingsByCityCode(
          this.selectedCityCode
        )) || { cities: null };
        if (!cities) {
          this.hasContent = false;
          return false;
        }

        if (
          cities &&
          Array.isArray(cities) &&
          cities.length &&
          lodashGet(cities, "[0].properties.ratings")
        ) {
          this.ratings = cities[0].properties.ratings;
        }
      } catch (error) {
        console.error(
          "There was an error trying to retrieve risk rating data for this city: " +
            this.selectedCityCode
        );
      } finally {
        this.loading = false;
      }

      return true;
    },
    getArrivalRatingIconClass(rating) {
      return (
        " " +
        lodashFind(ARRIVAL_RATING_TYPES, ["type", rating.type?.toLowerCase()])
          ?.iconClass +
        " " +
        lodashFind(ARRIVAL_RATING_LEVELS, [
          "value",
          rating.rating?.toLowerCase(),
        ])?.colorClass +
        " "
      );
    },
  },
  watch: {
    selectedLocation: {
      async handler() {
        this.cityDetails = null;
        if (this.selectedLocation && this.selectedLocation.iso2Code) {
          this.selectedCityCode = this.selectedLocation.selectedCity?.code
            ? this.selectedLocation.selectedCity?.code
            : this.cities[0]?.code;
          let selectedCity = lodashFind(this.cities, [
            "code",
            this.selectedCityCode,
          ]);
          selectedCity.type = "city";
          this.selectedCity = selectedCity;
          await this.handleChangeCity();
          this.risksPulseRatingsExpanded = null;
          this.resetExpanded = new Date().toISOString();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style>
.content-container img {
  max-width: 460px;
}
</style>

<style scoped>
.hyp-risks-content-expanded .hyp-grid-details-container {
  max-width: 50vw;
  margin: 12px auto;
}
.hyp-risk-details-container {
  margin: 0;
  padding: 0;
  max-width: unset !important;
  line-height: 1.5;
}
.hyp-risk-tab-items {
  height: calc(100vh - 120px);
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding-top: 0;
  padding-bottom: 0;
  max-width: unset !important;
}
.hyp-risk-tabs {
  text-transform: capitalize;
}

.hyp-risk-grid-2 {
  display: grid;
  grid-template-columns: 49.5% 49.5%;
  grid-column-gap: 1%;
  min-width: 900px;
  overflow-x: auto;
  grid-template-areas:
    "left right"
    "left right1"
    "left right2"
    "left right3";
}
.hyp-risk-grid-2-left {
  grid-area: left;
}
.hyp-risk-grid-2-leftgrid {
  display: grid;
}
.details-heading {
  font-size: 20px;
}
.hyp-back-to-country-btn {
  height: 48px !important;
  font-size: 0.875rem;
}
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 20px;
  line-height: 1;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 12px;
}
.hyp-risks-content-expanded
  .v-data-table--dense
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.hyp-risks-content-expanded
  .v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > td,
.hyp-risks-content-expanded
  .v-data-table--dense
  > .v-data-table__wrapper
  > table
  > tfoot
  > tr
  > td {
  height: 40px;
  line-height: 1.5;
}
.hyp-risks-content-expanded
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.hyp-risks-content-expanded
  .v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > td,
.hyp-risks-content-expanded
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tfoot
  > tr
  > td {
  font-size: 14px;
}
.hyp-risks-city-arrivals-cards {
  max-width: 32.5vw !important;
  min-width: 32.5vw !important;
  min-height: 100% !important;
}
.hyp-risks-city-arrival-rating-cards .v-card__text > div {
  font-size: 0.75rem !important;
  font-weight: bold !important;
}
.hyp-risks-city-image {
  max-width: 30vw !important;
}
.hyp-grid-image-container {
  text-align: center;
}
.hyp-risks-content-expanded .hyp-risks-city-image {
  max-width: 50vw !important;
  margin: unset !important;
}
.hyp-hide {
  display: none !important;
}
.hyp-link {
  cursor: pointer;
  color: #00ae42;
  text-decoration: underline;
}
.address-text {
  cursor: pointer;
  color: #00ae42;
}
@media (min-width: 900px) and (max-width: 1249px) {
  .cards-container {
    overflow-y: auto;
    max-height: 46vh;
  }
}
@media (min-width: 1250px) {
  .cards-container {
    overflow-y: auto;
    max-height: 80vh;
  }
}
.align-left-container {
  margin-left: 0;
}
.cards-container .card-content {
  display: flex;
  flex-direction: column;
}

.cards-container .title-section {
  flex: 1;
  margin-bottom: 1rem;
}

.cards-container .title-section h3 {
  margin: 0;
  white-space: pre-wrap; /* Allows the title to span two lines if needed */
}

.cards-container .contact-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
